import { required } from './shared';
import type { NopeContext, NopeValidator, ValidationResult, ValidationRule } from './shared';

class NopeArray {
  validationRules: ValidationRule[];
  itemValidator: NopeValidator | null;

  constructor() {
    this.validationRules = [];
    this.itemValidator = null;
  }

  required(message = 'This field is required'): this {
    this.validationRules.push(required(message));
    return this;
  }

  min(min: number, message = `Array must have at least ${min} items`): this {
    this.validationRules.push((value) => (value as unknown[]).length < min && message);
    return this;
  }

  max(max: number, message = `Array must have at most ${max} items`): this {
    this.validationRules.push((value) => (value as unknown[]).length > max && message);
    return this;
  }

  of(validator: NopeValidator): this {
    this.itemValidator = validator;
    return this;
  }

  validate(entry: unknown, context?: NopeContext): ValidationResult {
    if (!Array.isArray(entry)) {
      return 'Validation target must be an array.';
    }

    for (const rule of this.validationRules) {
      const error = rule(entry, context);
      if (error) {
        return error;
      }
    }

    const { itemValidator } = this;
    if (itemValidator && entry.length > 0) {
      const itemErrors = entry
        .map((item) => itemValidator.validate(item, context))
        .filter((error) => error !== undefined);

      if (itemErrors.length > 0) {
        return itemErrors[0];
      }
    }

    return undefined;
  }
}

export default NopeArray;
